import { cx } from "@/lib/cx";

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span
      role={label ? "status" : undefined}
      aria-label={label}
      className={cx(
        "inline-block size-4 rounded-full border-2 border-current border-e-transparent align-[-3px]",
        className,
      )}
      style={{ animation: "spin 700ms linear infinite" }}
    />
  );
}
